import React, {Component} from 'react';
import Radium from 'radium';
import color from 'color';

const MessageListText = (props) => {
	const 
        { message, isLastMessage, client, parentStyles, lastElement, handleMessageClick, pageState } = props,
        isLastUserMessageAndHasError = (
			message.get("isOwnedByUser") && 
			pageState.get('lastMessageHasError') && 
			isLastMessage
		);

    // TODO: The matchedArray length is wrong for some special emojis (eg. kissing lesbian emoji). Need to find better solution.
	// WIP - https://runkit.com/davidhariri/59132c619fd049001262fbee
    const containsOnlyEmojis = (string) => {
        const 
			matchedArray = string.match(/([\uD800-\uDBFF][\uDC00-\uDFFF]|[\u2000-\u3300]|[\u00A9-\u00AE]|[\uFE0F])/gm) || [],
			joinedMatched = matchedArray.join('');

		return string === joinedMatched && matchedArray.length <= 3;
    }

    return (
        <div 
            className="message m-type_text" 
            style={[message.get("isOwnedByUser") && parentStyles.message.isOwnedByUser]}
        >
            <div 
                className="message__body" 
                style={[
                    parentStyles.message.body,
                    message === lastElement && parentStyles.message.body.appear,
                    isLastUserMessageAndHasError && parentStyles.message.body.hasError,
                    message.get("isOwnedByUser") && {
                        backgroundColor: client.get("tint"),
                        color: 'white'
                    },
                    containsOnlyEmojis(message.get("body")) && parentStyles.message.body.emojis
                ]}
                onClick={() => {
                    if (isLastUserMessageAndHasError) {
                        handleMessageClick(message)
                    }
                }}
            >{message.get("body")}</div>
            {isLastUserMessageAndHasError &&
                <div 
                    className="message__error" 
                    style={[parentStyles.message.error]}
                    onClick={() => {
                        handleMessageClick(message)
                    }}
                >
                    Failed. Click to retry
                </div>
            }
        </div>
    )
}


export default Radium(MessageListText);


// WEBPACK FOOTER //
// ./src/components/MessageList/MessageListText.js